'use client';

import React from 'react';
import { IconRewindClock } from '@repo/svgs';
import ListCell from '@/components/ui/ListCell';
import { Divider } from '@/components/ui/Divider';
import { cn } from '@/lib/cn';
import type { RecentBuildingSearch } from '@/utils/recentSearches';
import { deriveBoroughFromAddress } from '@repo/utils';

export function BuildingSearchHistoryList({
  recentSearches,
  onSelect,
  variant = 'desktop',
  className,
}: {
  recentSearches: RecentBuildingSearch[];
  onSelect: (recent: RecentBuildingSearch) => void;
  variant?: 'desktop' | 'mobile';
  className?: string;
}) {
  if (!recentSearches.length) return null;

  const itemClassName =
    variant === 'desktop'
      ? 'bg-transparent rounded-xl hover:bg-secondary'
      : 'rounded-none shadow-none border-b border-tertiary';

  return (
    <div className={className}>
      <div className="flex flex-col gap-1">
        {recentSearches.map((r, idx) => (
          <React.Fragment key={r.buildingId}>
            <ListCell
              title={r.streetAddress}
              {...(() => {
                const borough = deriveBoroughFromAddress(r.fullAddress);
                return borough ? { subtitle: borough } : {};
              })()}
              leadingIcon={<IconRewindClock className="w-6 h-6 icon-secondary" />}
              onClick={() => onSelect(r)}
              className={itemClassName}
            />
            {variant === 'desktop' && idx !== recentSearches.length - 1 ? (
              <Divider variant="tertiary" className="mx-2" />
            ) : null}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
